import { render } from "./SidebarAccount.vue?vue&type=template&id=b7bb5518"
import script from "./SidebarAccount.vue?vue&type=script&lang=js"
export * from "./SidebarAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__